// styles/carouselStyles.js

export const carouselWrapper = (theme) => ({
  width: "100%",
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  padding: 0,
});

export const carouselContainer = (theme, isSmallScreen) => ({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  padding: 0,
});

export const carouselImage = (theme, isSmallScreen) => ({
  width: "100%",
  height: "auto",
  maxHeight: "60vh", // caps it visually on desktop
  aspectRatio: "4 / 3",
  objectFit: "cover",
  display: "block",
  margin: 0,
  padding: 0,
  borderRadius: theme.shape.borderRadius,
});

export const carouselTitle = (theme) => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
  textAlign: "center",
  backgroundColor: "rgba(255, 255, 255, 0.85)",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
  color: theme.palette.text.primary,
  padding: theme.spacing(1),
  fontWeight: 500,
  fontSize: "1rem",
});

export const carouselButton = (theme) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: "50%",
  boxShadow: theme.shadows[6],
  width: 40,
  height: 40,
  minHeight: 40,
  margin: theme.spacing(1),
  zIndex: 2,
  transition: "background-color 0.3s ease",
});
